import type { Theme } from '@mui/material';
// import type { Components } from '@mui/material/styles';

export default function MUIListItemText(theme: Theme) /* : Components['MuiListItemText'] */ {
  return {
    // defaultProps: {},
    styleOverrides: {
      root: {
        marginTop: 0,
        marginBottom: 0,
        color: theme.palette.text.primary,
      },
      multiline: {
        marginTop: 0,
        marginBottom: 0,
      },
    },
    // variants: [],
  };
}
